import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  useNavigationConfig,
  defaultNavigationLinks,
} from '../../context/NavigationConfigContext';
import './NavigationSettings.css';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

function NavigationSettings() {
  const { links, setLinks, resetLinks } = useNavigationConfig();
  const [draftLinks, setDraftLinks] = useState(links);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setDraftLinks(links);
  }, [links]);

  const handleLabelChange = (id, newLabel) => {
    setDraftLinks((prev) =>
      prev.map((item) => (item.id === id ? { ...item, label: newLabel } : item))
    );
  };

  const moveLink = (index, direction) => {
    setDraftLinks((prev) => {
      const next = [...prev];
      const targetIndex = direction === 'up' ? index - 1 : index + 1;
      if (targetIndex < 0 || targetIndex >= next.length) return prev;
      const temp = next[index];
      next[index] = next[targetIndex];
      next[targetIndex] = temp;
      return next;
    });
  };

  const handleReset = async () => {
    setDraftLinks(defaultNavigationLinks);
    resetLinks();

    try {
      await axios.put(`${API_BASE_URL}/api/navigation`, defaultNavigationLinks);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  };

  const handleSave = async () => {
    setIsSaving(true);

    try {
      const response = await axios.put(
        `${API_BASE_URL}/api/navigation`,
        draftLinks
      );
      if (Array.isArray(response.data?.links)) {
        setLinks(response.data.links);
      } else {
        setLinks(draftLinks);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="nav-settings">
      <div className="nav-settings-header">
        <div>
          <h2 className="nav-settings-title">Navigation links</h2>
          <p className="nav-settings-subtitle">
            Change the names and order of the header links used on the public website.
          </p>
        </div>
        <div className="nav-settings-actions">
          <button
            type="button"
            className="nav-settings-btn nav-settings-btn-secondary"
            onClick={handleReset}
          >
            Reset to default
          </button>
          <button
            type="button"
            className="nav-settings-btn"
            onClick={handleSave}
            disabled={isSaving}
          >
            {isSaving ? 'Saving…' : 'Save changes'}
          </button>
        </div>
      </div>

      <div className="nav-settings-list">
        {draftLinks.map((link, index) => (
          <div key={link.id} className="nav-settings-row">
            <div className="nav-settings-handle">
              <span className="nav-settings-index">{index + 1}</span>
            </div>

            <div className="nav-settings-main">
              <label className="nav-settings-label">
                Link label
                <input
                  type="text"
                  className="nav-settings-input"
                  value={link.label}
                  onChange={(e) => handleLabelChange(link.id, e.target.value)}
                />
              </label>
            </div>

            <div className="nav-settings-meta">
              <p className="nav-settings-path">{link.path}</p>
              {link.type === 'services' && (
                <p className="nav-settings-tag">Dropdown: Our Practices</p>
              )}
            </div>

            <div className="nav-settings-order">
              <button
                type="button"
                className="nav-settings-order-btn"
                onClick={() => moveLink(index, 'up')}
                disabled={index === 0}
              >
                ↑
              </button>
              <button
                type="button"
                className="nav-settings-order-btn"
                onClick={() => moveLink(index, 'down')}
                disabled={index === draftLinks.length - 1}
              >
                ↓
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default NavigationSettings;

